const rateList = (state) => state.rateList;


export default {
  rateList,
}


// WEBPACK FOOTER //
// ./src/store/modules/rateManagement/getters.js